/* =========================================================
   INKSOFT RELATED PRODUCTS MODULE
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.relatedProducts = (function () {
  const core = window.InksoftPOC.core;
  const utils = window.InksoftPOC.productUtils || {};

  const asArray = typeof utils.asArray === 'function'
    ? utils.asArray
    : function (value) {
        return Array.isArray(value) ? value : [];
      };

  const asString = typeof utils.asString === 'function'
    ? utils.asString
    : function (value) {
        return value == null ? '' : String(value).trim();
      };

  const normalizeInksoftUrl = typeof utils.normalizeInksoftUrl === 'function'
    ? utils.normalizeInksoftUrl
    : function (url) {
        return asString(url);
      };

  const trackState = {};

  function getVisibleCount() {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 980) return 3;
    if (window.innerWidth <= 1400) return 4;
    return 6;
  }

  function buildProductUrl(product) {
    const id = product && (product.id || product.ID || product.Id || '');
    return id ? `/pages/inksoft-product?id=${encodeURIComponent(String(id))}` : '#';
  }

  function ensureTrackState(trackId, totalItems) {
    if (!trackState[trackId]) {
      trackState[trackId] = { page: 0, totalItems: 0 };
    }

    trackState[trackId].totalItems = totalItems || 0;
    return trackState[trackId];
  }

  function setTrackTransform(trackId) {
    const trackEl = document.getElementById(trackId);
    if (!trackEl) return;

    const inner = trackEl.querySelector('.inksoft-related-track-inner');
    if (!inner) return;

    const state = trackState[trackId];
    if (!state) return;

    const visibleCount = getVisibleCount();
    const maxPage = Math.max(0, Math.ceil(state.totalItems / visibleCount) - 1);

    if (state.page > maxPage) {
      state.page = maxPage;
    }

    inner.style.transform = `translateX(-${state.page * 100}%)`;
  }

  function refreshAllTracks() {
    Object.keys(trackState).forEach(setTrackTransform);
  }

  function renderCards(targetEl, items, typeLabel) {
    const list = asArray(items);

    if (!targetEl) return;

    if (!list.length) {
      targetEl.innerHTML = '';
      return;
    }

    targetEl.innerHTML = `
      <div class="inksoft-related-track-inner">
        ${list.map(function (item) {
          const image = normalizeInksoftUrl(asString(item && (item.thumbnailUrl || item.ThumbnailUrl || item.imageUrl || item.ImageUrl)));
          const id = item && (item.id || item.ID || item.Id || item.productId || item.ProductId || '');
          const brand = asString(item && (item.brand || item.Brand));
          const sku = asString(item && (item.sku || item.Sku || item.manufacturerSku || item.ManufacturerSku));
          const name = asString(item && (item.name || item.Name || item.title || item.Title)) || 'Product';

          return `
            <div class="inksoft-related-card">
              <div class="inksoft-related-card__image-wrap">
                ${
                  image
                    ? `<img class="inksoft-related-card__image" src="${core.escapeHtml(image)}" alt="${core.escapeHtml(name)}" width="320" height="320">`
                    : `<div class="inksoft-product-empty">No image</div>`
                }
              </div>

              <div class="inksoft-related-card__body">
                <div class="inksoft-related-card__tag">${core.escapeHtml(typeLabel)}</div>

                <h3 class="inksoft-related-card__title">${core.escapeHtml(name)}</h3>

                <div class="inksoft-related-card__meta">
                  ${brand ? `${core.escapeHtml(brand)}<br>` : ''}
                  ${sku ? `SKU: ${core.escapeHtml(sku)}` : '&nbsp;'}
                </div>

                <div class="inksoft-related-card__actions">
                  <button
                    type="button"
                    class="inksoft-related-card__preview"
                    data-preview-product-id="${core.escapeHtml(String(id))}"
                  >
                    Quick Preview
                  </button>

                  <a
                    class="inksoft-related-card__link"
                    href="${core.escapeHtml(buildProductUrl(item))}"
                  >
                    View Product
                  </a>
                </div>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;

    ensureTrackState(targetEl.id, list.length);
    setTrackTransform(targetEl.id);

    Array.prototype.forEach.call(
      targetEl.querySelectorAll('[data-preview-product-id]'),
      function (button) {
        button.addEventListener('click', function () {
          const productId = button.getAttribute('data-preview-product-id') || '';

          if (window.InksoftPOC && window.InksoftPOC.modal && productId) {
            if (typeof window.InksoftPOC.modal.openProductQuickView === 'function') {
              window.InksoftPOC.modal.openProductQuickView(productId);
              return;
            }

            window.InksoftPOC.modal.open(`
              <div class="inksoft-modal-content">
                <button class="inksoft-modal-close inksoft-btn" type="button" style="margin-bottom:16px;">Close</button>
                <div class="inksoft-loader">Quick Preview unavailable. Product ID: ${core.escapeHtml(productId)}</div>
              </div>
            `);
          }
        });
      }
    );
  }

  function bindScrollButtons(sectionEl) {
    if (!sectionEl) return;

    Array.prototype.forEach.call(sectionEl.querySelectorAll('.inksoft-related-scroll'), function (button) {
      button.addEventListener('click', function () {
        const trackId = button.getAttribute('data-scroll-target');

        if (!trackId || !trackState[trackId]) return;

        const state = trackState[trackId];
        const visibleCount = getVisibleCount();
        const maxPage = Math.max(0, Math.ceil(state.totalItems / visibleCount) - 1);
        const isLeft = button.classList.contains('inksoft-related-scroll--left');

        if (isLeft) {
          state.page = Math.max(0, state.page - 1);
        } else {
          state.page = Math.min(maxPage, state.page + 1);
        }

        setTrackTransform(trackId);
      });
    });
  }

  function render(containerEl, relatedProducts) {
    if (!containerEl) return;

    const comparable = asArray(
      relatedProducts && (
        relatedProducts.comparable ||
        relatedProducts.comparableProducts
      )
    );

    const companion = asArray(
      relatedProducts && (
        relatedProducts.companion ||
        relatedProducts.companionProducts
      )
    );

    const hasComparable = comparable.length > 0;
    const hasCompanion = companion.length > 0;

    if (!hasComparable && !hasCompanion) {
      containerEl.innerHTML = '';
      return;
    }

    containerEl.innerHTML = `
      <section class="inksoft-related-products-section">
        ${
          hasComparable
            ? `
              <div class="inksoft-related-block" id="inksoft-comparable-section">
                <div class="inksoft-related-block__head">
                  <h2 class="inksoft-related-block__title">Comparable Products</h2>
                  <p class="inksoft-related-block__subtitle">Alternative products matched from backend-resolved related-product tags.</p>
                </div>

                <div class="inksoft-related-carousel">
                  <button
                    type="button"
                    class="inksoft-related-scroll inksoft-related-scroll--left"
                    data-scroll-target="inksoft-comparable-track"
                    aria-label="Scroll comparable products left"
                  >‹</button>

                  <div id="inksoft-comparable-track" class="inksoft-related-track"></div>

                  <button
                    type="button"
                    class="inksoft-related-scroll inksoft-related-scroll--right"
                    data-scroll-target="inksoft-comparable-track"
                    aria-label="Scroll comparable products right"
                  >›</button>
                </div>
              </div>
            `
            : ''
        }

        ${
          hasCompanion
            ? `
              <div class="inksoft-related-block" id="inksoft-companion-section">
                <div class="inksoft-related-block__head">
                  <h2 class="inksoft-related-block__title">Companion Products</h2>
                  <p class="inksoft-related-block__subtitle">Cross-sell products matched from backend-resolved related-product tags.</p>
                </div>

                <div class="inksoft-related-carousel">
                  <button
                    type="button"
                    class="inksoft-related-scroll inksoft-related-scroll--left"
                    data-scroll-target="inksoft-companion-track"
                    aria-label="Scroll companion products left"
                  >‹</button>

                  <div id="inksoft-companion-track" class="inksoft-related-track"></div>

                  <button
                    type="button"
                    class="inksoft-related-scroll inksoft-related-scroll--right"
                    data-scroll-target="inksoft-companion-track"
                    aria-label="Scroll companion products right"
                  >›</button>
                </div>
              </div>
            `
            : ''
        }
      </section>
    `;

    if (hasComparable) {
      renderCards(document.getElementById('inksoft-comparable-track'), comparable, 'Comparable');
    }

    if (hasCompanion) {
      renderCards(document.getElementById('inksoft-companion-track'), companion, 'Companion');
    }

    bindScrollButtons(containerEl);

    window.removeEventListener('resize', refreshAllTracks);
    window.addEventListener('resize', refreshAllTracks);
  }

  return {
    render: render,
    refreshAllTracks: refreshAllTracks
  };
})();